// src/store/slices/clientProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ClientProfileState {
    selectedView: string;
    navigationClientId: string | null;
    navigationOrganisingCorporationId: string | null;
}

const initialState: ClientProfileState = {
    selectedView: '/info',
    navigationClientId: null,
    navigationOrganisingCorporationId: null,
};

const clientProfileSlice = createSlice({
    name: 'clientProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
        setNavigationContext(
            state,
            action: PayloadAction<{ clientId: string | null; organisingCorporationId: string | null }>
        ) {
            state.navigationClientId = action.payload.clientId;
            state.navigationOrganisingCorporationId = action.payload.organisingCorporationId;
        },
    },
});

export const { setSelectedView, setNavigationContext } = clientProfileSlice.actions;
export default clientProfileSlice.reducer;
